import { gql, TypedDocumentNode } from "@apollo/client";
import type { RosterActivityCohort, RosterActivityEventFromApi, RosterActivityKind } from "./types";

export type SectionRosterActivityResponse = {
  section: {
    id: string;
    name: string;
    legacyId?: string | null;
    rosterActivity: RosterActivityEventFromApi[];
  };
};

export type SectionRosterActivityVariables = {
  sectionId: string;
  startDateTime: string;
  endDateTime: string;
  kinds?: RosterActivityKind[];
  cohorts?: RosterActivityCohort[];
};

export const SECTION_ROSTER_ACTIVITY_QUERY: TypedDocumentNode<
  SectionRosterActivityResponse,
  SectionRosterActivityVariables
> = gql`
  query SectionRosterActivity(
    $sectionId: ID!
    $startDateTime: ISO8601DateTime!
    $endDateTime: ISO8601DateTime!
    $kinds: [BackofficeRosterActivityKind!]
    $cohorts: [BackofficeRosterActivityCohort!]
  ) {
    section(id: $sectionId) {
      id
      name
      legacyId
      rosterActivity(startDateTime: $startDateTime, endDateTime: $endDateTime, kinds: $kinds, cohorts: $cohorts) {
        id
        occurredAt
        kind
        cohort
        headline
        detail
        personName
        pgaId
        linkPath
        person {
          firstName
          lastName
          primaryFacility {
            name
          }
        }
      }
    }
  }
`;
